module.exports = __webpack_public_path__ + "static/media/ageelementfirmingcream.bfc517f3.png";